module.exports = __webpack_public_path__ + "img/mail.032ff484.svg";